import React from 'react';
import cx from 'classnames';

const LEGEND_VALUES = {
  DRAFT: 1,
  ATL_ASSIGNED: 2,
  OPEN_FOR_BID: 3,
  TEAM_ASSIGNED: 4,
  READY_TO_DELIVER: 5
};

const LEGENDS = [
  {
    NAME: 'Draft',
    VALUE: LEGEND_VALUES.DRAFT,
    CLASS_Name: 'draft'
  },
  {
    NAME: 'ATL Assigned',
    VALUE: LEGEND_VALUES.ATL_ASSIGNED,
    CLASS_Name: 'atl-assigned'
  },
  {
    NAME: 'Open for Bid',
    VALUE: LEGEND_VALUES.OPEN_FOR_BID,
    CLASS_Name: 'open-for-bid'
  },
  {
    NAME: 'Team Assigned',
    VALUE: LEGEND_VALUES.TEAM_ASSIGNED,
    CLASS_Name: 'team-assigned'
  },
  {
    NAME: 'Ready to Deliver',
    VALUE: LEGEND_VALUES.READY_TO_DELIVER,
    CLASS_Name: 'ready-to-deliver'
  }
];

/**
 * @typedef {object} ClickableLegendsProps
 * @property {number} [selectedLegend]
 * @property {(legend: number | null) => void} [setSelectedLegend]
 */

/**
 * @param {ClickableLegendsProps} props
 */
export const ClickableLegends = props => {
  const { selectedLegend, setSelectedLegend } = props;

  const handleSelectLegend = value => setSelectedLegend(selectedLegend === value ? null : value);

  return (
    <div className='clickable-legends'>
      {LEGENDS.map(legend => (
        <button
          key={legend.VALUE}
          className={legend.CLASS_Name}
          onClick={() => handleSelectLegend(legend.VALUE)}>
          <span className={cx({ bold: selectedLegend === legend.VALUE })}>{legend.NAME}</span>
        </button>
      ))}
    </div>
  );
};
